import { Injectable } from '@angular/core';
import { EventService } from './event.service';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {

  private readonly KEY_PHONE_NUMBER = 'phoneNumber';
  private readonly KEY_SCANNER_SIZE_MULTIPLIER = 'scannerSizeMultiplier';
  private readonly KEY_PREFERRED_DEVICE_ID = 'preferredDeviceId';
  private readonly KEY_LOW_POWER_SCANNING = 'lowPowerScanning';
  private readonly KEY_HIDE_ITEMS_BAR = 'hideItemsBar';

  constructor(private events: EventService) {
  }

  getPhoneNumber(): string {
    const phoneNumber = localStorage.getItem(this.KEY_PHONE_NUMBER);
    if (phoneNumber && phoneNumber.length > 0) {
      this.events.phoneNumberChanged.next(phoneNumber);
    }
    return phoneNumber;
  }

  clearPhoneNumber(): void {
    localStorage.removeItem(this.KEY_PHONE_NUMBER);
  }

  savePhoneNumber(phoneNumber: string): void {
    localStorage.setItem(this.KEY_PHONE_NUMBER, phoneNumber);
    this.events.phoneNumberChanged.next(phoneNumber);
  }

  getScannerSizeMultiplier(): number {
    const scannerSizeMultiplierString = localStorage.getItem(this.KEY_SCANNER_SIZE_MULTIPLIER);
    const scannerSizeMultiplier = parseFloat(scannerSizeMultiplierString) || 1;
    if (scannerSizeMultiplier && scannerSizeMultiplier > 0) {
      this.events.scannerSizeMultiplierChanged.next(scannerSizeMultiplier);
    }
    return scannerSizeMultiplier;
  }

  clearScannerSizeMultiplier(): void {
    localStorage.removeItem(this.KEY_SCANNER_SIZE_MULTIPLIER);
  }

  saveScannerSizeMultiplier(scannerSizeMultiplier: number): void {
    localStorage.setItem(this.KEY_SCANNER_SIZE_MULTIPLIER, scannerSizeMultiplier.toString());
    this.events.scannerSizeMultiplierChanged.next(scannerSizeMultiplier);
  }

  get preferredCameraDeviceId(): string | undefined {
    return localStorage.getItem(this.KEY_PREFERRED_DEVICE_ID) ?? undefined;
  }

  setPreferredCameraDeviceId(deviceId: string): void {
    localStorage.setItem(this.KEY_PREFERRED_DEVICE_ID, deviceId);
    console.log(`Using preferred device id: ${deviceId}`);
  }

  clearPreferredCameraDeviceId(): void {
    localStorage.removeItem(this.KEY_PREFERRED_DEVICE_ID);
    console.log(`Cleared preferred device id`);
  }

  get lowPowerScanning(): boolean {
    return localStorage.getItem(this.KEY_LOW_POWER_SCANNING) === 'true' ?? false;
  }

  setLowPowerScanning(enabled: boolean) {
    localStorage.setItem(this.KEY_LOW_POWER_SCANNING, enabled ? 'true' : 'false');
  }

  /**
   * Indicates if the items bar should be hidden in the tour view or not.
   */
  get hideItemsBar(): boolean {
    return localStorage.getItem(this.KEY_HIDE_ITEMS_BAR) === 'true' ?? false;
  }

  setHideItemsBar(enabled: boolean) {
    localStorage.setItem(this.KEY_HIDE_ITEMS_BAR, enabled ? 'true' : 'false');
  }
}
